/* eslint-disable @typescript-eslint/ban-ts-comment */
import {withTranslation} from "react-i18next";
import {Button} from "antd";
import {useTranslation} from "react-i18next";
import {DownloadOutlined} from "@ant-design/icons";
import {PDFDownloadLink, Font} from "@react-pdf/renderer";
import "moment/locale/es";
import source1Font from "../../assets/fonts/futura-book.otf";
import source2Font from "../../assets/fonts/futura-medium.woff";
import source3Font from "../../assets/fonts/futura-bold.woff";
import { MyDocPDFCenterTemplate } from "./components/pdfcontracttemplate";

Font.register({
  family: "Futura",
  fonts: [{src: source1Font}, {src: source2Font, fontWeight: 500}, {src: source3Font, fontWeight: 700}],
});
Font.registerHyphenationCallback((word) => [word]);

function RegisterPDFCenter(props) {
  const {t} = useTranslation();
  return (
    <>
      <PDFDownloadLink
        document={<MyDocPDFCenterTemplate props={props} />}
        fileName={t("registercenter.infosubir") + "20" + +props.year + "/20" + (+props.year + 1) + ".pdf"}
      >
        {({blob, url, loading, error}) =>
          loading ? (
            "Loading document..."
          ) : (
            <>
              <Button className="primaryButton" type="primary" icon={<DownloadOutlined />}>
                {t("registercenter.descargar")}
              </Button>
              {props.download()}
            </>
          )
        }
      </PDFDownloadLink>
    </>
  );
}

export default withTranslation()(RegisterPDFCenter);
